export default __webpack_public_path__ + "a83bf2f941550eb0ab5ed1443c1fe5e1.svg";